import React from "react";
import "./card.css";

interface CardProps {
  children: React.ReactNode;
  className?: string;
  isbordered?: boolean;
  backgroundColor?: string; // Accepts color value like "#fff" or "red"
}

const Card: React.FC<CardProps> = ({
  children,
  className = "",
  isbordered = true,
  backgroundColor = 'var(--bg-secondary)',
}) => {
  return (
    <div
      className={`card-container ${!isbordered ? "no-bordered" : ""} ${className}`}
      style={{ backgroundColor: backgroundColor || undefined }} // Only apply if provided
    >
      {children}
    </div>
  );
};

export default Card;
